import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IDomainExpandedDataState} from "../reducers/domain-expanded-data.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getDomainExpandedDataState = createSelector(
  getDbStoreState,
  (dbStoreState: DbStoreState) => dbStoreState.domainExpandedData
);

export const getDomainExpandedData = (domainId: number) => createSelector( getDomainExpandedDataState,
    (state: IDomainExpandedDataState) => state.entities && state.entities[domainId] || null
  );
